import CastCard from './CastCard';

export default CastCard;
